import { render, staticRenderFns } from "./HowItWorks.vue?vue&type=template&id=8790d2f4&scoped=true&"
import script from "./HowItWorks.vue?vue&type=script&lang=ts&"
export * from "./HowItWorks.vue?vue&type=script&lang=ts&"
import style0 from "./HowItWorks.vue?vue&type=style&index=0&id=8790d2f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8790d2f4",
  null
  
)

export default component.exports